import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import { LocalizedEnum, LocalizedStrict } from "../../../../modules/localization/components/AppLocalized"
import { iterateStringEnum } from "../../../../lib/enums"
import { DateTime } from "luxon"

export enum DatePeriod {
    ALL = "ALL",
    TODAY = "TODAY",
    TOMORROW = "TOMORROW",
    THIS_WEEK = "THIS_WEEK",
    THIS_MONTH = "THIS_MONTH",
}

type SelectDatePeriodFilterProps = {
    datePeriod: DatePeriod
    setDatePeriod: (val: DatePeriod) => void
    className?: string
}

interface TimePeriodResult {
    start: DateTime
    end: DateTime
}

export const getTimePeriod = (period: DatePeriod): TimePeriodResult => {
    switch (period) {
        case DatePeriod.TODAY:
            return {
                start: DateTime.now().startOf("day"),
                end: DateTime.now().endOf("day"),
            }
        case DatePeriod.TOMORROW:
            return {
                start: DateTime.now().plus({ days: 1 }).startOf("day"),
                end: DateTime.now().plus({ days: 1 }).endOf("day"),
            }
        case DatePeriod.THIS_WEEK:
            return {
                start: DateTime.now().startOf("week"),
                end: DateTime.now().endOf("week"),
            }
        case DatePeriod.THIS_MONTH:
            return {
                start: DateTime.now().startOf("month"),
                end: DateTime.now().endOf("month"),
            }
        default:
            return {
                start: DateTime.now().startOf("day"),
                end: DateTime.now().endOf("day"),
            }
    }
}

export function SelectDatePeriodFilter({ datePeriod, setDatePeriod, className }: SelectDatePeriodFilterProps) {
    return (
        <FormControl sx={{ minWidth: "13rem" }}>
            <LocalizedStrict id="table-select-date-period-filter-by-label">
                <InputLabel id="pos-table-select-filter-by-date-period">Period</InputLabel>
            </LocalizedStrict>
            <LocalizedStrict id="table-select-date-period-filter-by-label-label" attrs={{ label: true }}>
                <Select
                    labelId="pos-table-select-filter-by-date-period"
                    id="pos-table-filter-by-date-period"
                    value={datePeriod}
                    label="Period"
                    onChange={(e) => setDatePeriod(e.target.value as DatePeriod)}
                    className={className}
                >
                    {[...iterateStringEnum(DatePeriod)].map((value) => (
                        <MenuItem key={value} value={value}>
                            <LocalizedEnum base="table-select-date-period-filter-by" enumValue={value}>
                                <span>{value}</span>
                            </LocalizedEnum>
                        </MenuItem>
                    ))}
                </Select>
            </LocalizedStrict>
        </FormControl>
    )
}
